import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DateRangeInterval } from '../../../core/components/date-range/date-range.component';

@Component({
  selector: 'tt-time-sheet-pow-time-list',
  templateUrl: './time-sheet-pow-time-list.component.html',
  styleUrls: ['./time-sheet-pow-time-list.component.css']
})
export class TimeSheetPowTimeListComponent implements OnInit {
    labourNo;

    dateSelector;

    public setting?: Setting;

    public itemsListPowTimes: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.labourNo = this.stateService.getStateParams()['labour_no'];
        this.dateSelector = this.stateService.getStateParams()['dateselector'];
    }

    private async loadSetting() {
        if (!!this.labourNo && !!this.dateSelector) {
            this.setting = (await this.datatask.Post(986, {
                labour_no: this.labourNo,
                dateselector: this.dateSelector
            }))[0];
        }
    }

    private async loadPowTimes() {
        if (!this.setting) return;

        return this.itemsListPowTimes = await this.datatask.Post(295, this.setting);
    }

    public onDateRangeChanged() {
        this.loadPowTimes();
    }

    private async init() {
        await this.loadSetting();
        this.loadPowTimes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    labour_no: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
}
